import _ from 'underscore'
import gsap from 'gsap'
// import { Power2 } from 'gsap'
import koko from '../koko-framework/koko'
import { v, a, au } from '../koko-framework/shorthand'
import app from '../koko-framework/app'
import main from '../main'
import gameState from '../model/GameModel'

export class PreloaderView extends koko.view {
    constructor () {
        super();

        this.updateLoadingBar = this.updateLoadingBar.bind(this);
        this.finishLoading = this.finishLoading.bind(this);
    }

    assets = [
        // { id: 'preloader', src: 'img/preloader_assets.json' },
        { id: 'loading_words', src: 'img/loading_words.json' },
        { id: 'font', src: 'img/fonts/HelvBold.fnt' },
        // { id: 'bg', src: 'img/bluebg.png' },
    ];

    gfxPerc = 0;

    loadedSounds = false;
    loadedGraphics = false;

    disabled = false;
    mobileTapToStart = false;

    currentWord = 1;
    
    buildView () {
        var vp = app.viewPort;

        this.children = koko.display.buildLayout([
            { type: 'sprite', name: 'loading1', id: 'loading_text', x: vp.centerX, y: vp.centerY - 100, anchorX: 0.5, anchorY: 0, width: 127, height: 62 },
            { type: 'sprite', name: 'loading2', id: 'loading_text_2', x: vp.centerX, y: vp.centerY - 100, anchorX: 0.5, anchorY: 0, width: 140, height: 62 },
            { type: 'sprite', name: 'loading3', id: 'loading_text_3', x: vp.centerX, y: vp.centerY - 100, anchorX: 0.5, anchorY: 0, width: 224, height: 62 },
            // { type: 'sprite', name:'bg', id: 'bg', x: vp.centerX, y: vp.centerY, regX: 1388, regY: 765},
            // { type: 'sprite', name: 'greyLine', id: 'loadingbar', x: vp.centerX, y: vp.centerY + 100, regX: 292, regY: 0, width: 584, height: 92 },
            // { type: 'bmptext', text: '0%', font: 'HelveticaBold', size: 48, align: 'center', tint: 0, name: 'loadingText', x: vp.centerX, y: vp.centerY + 142},
            // { type: 'sprite', name: 'pokeball', id: 'pokeball_sillhouette', x: vp.centerX, y: vp.centerY, regX: 115.5, regY: 116, width: 115.5, height: 116},

            { type: 'sprite', name: 'loadbar_back', id: 'loader_mask', x: vp.centerX, y: vp.centerY + 20, anchorX: 0.5, anchorY: 0.5, width: 412, height: 78 },
            { type: 'sprite', name: 'loadbar_fill', id: 'loader_Fill', x: vp.centerX - 378, y: vp.centerY + 20, anchorX: 0.5, anchorY: 0.5, width: 412, height: 78 },
            { type: 'sprite', name: 'loadbar_top', id: 'loader_top', x: vp.centerX, y: vp.centerY + 20, anchorX: 0.5, anchorY: 0.5, width: 412, height: 78 },

            { type: 'shape', name: 'loadbar_mask', x: vp.centerX - 189, y: vp.centerY + 20 - 22, width: 378, height: 44, fill: 0x005500, alpha: 0.5 },

            { type: 'sprite', name: 'continue_btn', id: 'continue_loader_btn', x: vp.centerX, y: vp.centerY + 90, anchorX: 0.5, anchorY: 0, width: 434, height: 105 },
        ], this.container);

        // this.children.loadingText.anchor.x = this.children.loadingText.anchor.y = 0.5;
        // gsap.to(this.children.pokeball, {rotation: Math.PI * 2, ease: Power2.easeInOut, repeat: -1, duration: 1});
        this.children.loading2.alpha = 0;
        this.children.loading3.alpha = 0;

        this.children.continue_btn.visible = false;

        this.children.loadbar_fill.mask = this.children.loadbar_mask;

        setTimeout(this.swapLoadingText, 1000);
    }

    swapLoadingText = () => {
        if (this.children && this.children.loading1) {
            gsap.to(this.children['loading' + this.currentWord], {alpha: 0, duration: 0.3});
            this.currentWord++;
            if (this.currentWord > 3) {
                this.currentWord = 1;
            }
            gsap.to(this.children['loading' + this.currentWord], {alpha: 1, duration: 0.3});
            setTimeout(this.swapLoadingText, 1000);
        }
    }

    updateLoadingBar () {
        var vp = app.viewPort;
        var p = this.gfxPerc;

        if (main.soundsToLoad > 0) {
            p *= 0.5;
            p += koko.audio.loaded / main.soundsToLoad * 0.5;
            if (koko.audio.loaded >= main.soundsToLoad) {
                this.loadedSounds = true;
            }
        }

        // this.children.fillLine.scale.x = p;
        // this.children.loadingText.text = Math.floor(p * 100) + '%';
        this.children.loadbar_fill.x = (vp.centerX - 378) + (p * 378);

        if (this.loadedSounds && this.loadedGraphics) {
            setTimeout(this.finishLoading, 500);
        }

        gsap.killTweensOf(this.finishLoading);
        gsap.delayedCall(2, this.finishLoading);

        // console.log('perc: ', p);
    }

    transitionIn () {
        if (_.size(this.children) === 0) {
            this.buildView();
            this.show();
        }

        // load the assets
        main.setupAudio();

        this.loadedGraphics = false;
        this.loadedSounds = main.soundsToLoad > 0 ? false : true;
        this.loadedTimeWait = false;

        document.body.insertBefore(app.renderer.view, null);

        // load the graphics for the rest of the game
        a.loadManifest(function (perc) {
            this.gfxPerc = perc;
            this.updateLoadingBar();
        }.bind(this), function () {
            this.loadedGraphics = true;
        }.bind(this));


        // load audio
        if (main.soundsToLoad > 0) {
            koko.audio.progressHandler = this.updateLoadingBar;
            koko.audio.load();
            //koko.audio.giveupTimer(5000);
        }

        this.show();
    }

    finishLoading () {
        gsap.killTweensOf(this.finishLoading);
        if (this.loadedSounds && this.loadedGraphics) {
            // gsap.killTweensOf(this.children.pokeball);
            //tap to start
            // if (c.system.isMobile && this.mobileTapToStart) {
                var tappedToStart = function (e) {
                    this.children.continue_btn.interactive = false;
                    this.transitionOut();
                    // app.renderer.view.removeEventListener(c.eventName('down'), tappedToStart);
                }.bind(this);

                //app.renderer.view.addEventListener(c.eventName('down'), tappedToStart);
                this.children.continue_btn.visible = true;
                // let event = koko.client.system.isMobile ? 'touchstart' : 'mousedown';
                this.children.continue_btn.interactive = true;
                this.children.continue_btn.on('pointerdown', tappedToStart);
                this.children.continue_btn.on('mousedown', tappedToStart);
                this.children.continue_btn.on('touchstart', tappedToStart);
            // } else {
                // this.transitionOut();
            // }
        } else {
            gsap.delayedCall(1, this.finishLoading);
        }
    }

    transitionOut () {
        if (!this.disabled) {
            gsap.to(this.container, {alpha: 0, duration: 0.35, onComplete: this.transitionOutDone});
        }
    }

    transitionOutDone = () => {
        if (!this.disabled) {
            gsap.killTweensOf([this.children.loading1, this.children.loading2, this.children.loading3]);
            this.disabled = true;
            this.disable();
            this.destroyView();
            this.hide();

            this.gotoApp();
        }
    }

    gotoApp () {
        console.log("--------------------------------------------");
        console.log("OPEN UNIVERSITY CODEBREAKER - v1.0.0")
        console.log("--------------------------------------------");
        // console.log(app.viewPort);
        // v.each(['mainmenu'], 'transitionIn');
        gameState.reset();
        v.each([/*'ingamehud',*/ 'mainmenu'/*, 'gameover'*/], 'transitionIn');
        au.play('music', 1, true);
    }
}
